<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h2>Add Announcement</h2>
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <ValidationForm :onSubmit="submit">
          <div class="form-group">
            <label for="txtName">Name</label>
            <input type="text" class="form-control" id="txtName" v-model="notification.name">
          </div>
          <ValidationField
            id="txtExtension"
            label="Extension"
            helperText="Not required, but can only play from web interface if left at 9. If inputted, must keep leading 9 and follow with 3 numbers. Example: 9001"
            v-model="notification.extension" 
            :validator="validate"
          ></ValidationField>
          <div class="form-group">
            <label for="ddlZone">Zone</label>
            <v-select
              id="ddlZone"
              v-model="notification.zone"
              :options="zones_for_drop_down"
              placeholder="Select.."></v-select>
          </div>
          <div class="form-group">
            <label for="ddlSoundType">Sound Type</label>
            <select class="form-control" id="ddlSoundType" v-model="notification.sound_type_id">
              <option v-for="sound_type in sound_types" :key="sound_type.sound_type_id" v-bind:value="sound_type.sound_type_id">
                {{ sound_type.name }}
              </option>
            </select>
          </div>
          <div v-if="notification.sound_type_id === 1">
            <SoundDropDownAndPreview tag="announcement" v-model="notification.sound"></SoundDropDownAndPreview>
          </div>
          <div v-else-if="[2,3,4].includes(notification.sound_type_id)">
            <label for="ddlPlaylist">Playlist</label>
            <select class="form-control" id="ddlPlaylist" v-model="notification.playlist_id">
              <option value="0">Select..</option>
              <option v-for="playlist in filtered_playlists" :key="playlist.playlist_id" v-bind:value="playlist.playlist_id">
                {{ playlist.name }}
              </option>
            </select>
            <br>
          </div>
          <button type="submit" class="btn btn-hub-primary" >Submit</button>
          <router-link :to="{ name: 'Notifications' }" class="btn btn-secondary">Cancel</router-link>
        </ValidationForm>
      </div>
      <div class="col-4">
          <CurrentExtensions :default_type="'announcement'"></CurrentExtensions>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import CurrentExtensions from '../../components/CurrentExtensions'
import SoundDropDownAndPreview from '../../components/SoundDropDownAndPreview'
import ValidationMixin from '../../mixins/ValidationMixin.vue'
import { AlertExtensionValidator } from '../../assets/js/validators'

export default {
  components: { vSelect, CurrentExtensions, SoundDropDownAndPreview },
  mixins: [ValidationMixin],
  data: function () {
    return {
      notification: {
        notification_id: 0,
        name: '',
        extension: '9',
        zone_id: 0,
        sound_type_id: 1,
        sound_id: 0,
        playlist_id: 0,
        sound: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      sound_types: 'allSoundTypes',
      playlists: 'allPlaylists',
      zones_for_drop_down: 'allZonesForDropdown', // TODO Account for Zone Tags COMM-188
      scoped_site_id: 'scopedSiteId'
    }),
    filtered_playlists: function () {
      return this.playlists.filter(playlist => playlist.site_id === this.scoped_site_id)
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
    this.$store.dispatch('getZones')
    this.$store.dispatch('getSoundTypes')
    this.$store.dispatch('getPlaylists')
  },
  methods: {
    validate(value) {
      const validator = new AlertExtensionValidator(this.extensions_in_use)
      return validator.validate(value)
    },
    submit () {
      this.$store.dispatch('addEditNotification', this.notification)
    }
  }
}
</script>

<style scoped>

</style>
